/**
 * EmailCreateRedirect — entry point para "Criar e-mail".
 *
 * Substitui o auto-create que o EmailStepper fazia ao abrir /emails/create:
 * cria uma campanha vazia e redireciona para /emails/:id/editor (Emails.tsx).
 * Em caso de falha, volta para o dashboard.
 */

import { useEffect, useRef } from "react";
import { useLocation } from "wouter";
import { trpc } from "@/lib/trpc";
import { toast } from "sonner";
import { toUserFriendlyError } from "@/lib/error-messages";
import { Loader2 } from "lucide-react";

export default function EmailCreateRedirect() {
  const [, navigate] = useLocation();
  const startedRef = useRef(false);

  const createMutation = trpc.emailCampaigns.create.useMutation({
    onSuccess: (data) => {
      if (data?.id) navigate(`/emails/${data.id}/editor`, { replace: true });
      else navigate("/emails", { replace: true });
    },
    onError: (err) => {
      toast.error(toUserFriendlyError(err, "Erro ao criar e-mail"));
      navigate("/emails", { replace: true });
    },
  });

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    createMutation.mutate({ name: "Novo E-mail" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex items-center justify-center h-screen text-muted-foreground gap-2">
      <Loader2 className="h-5 w-5 animate-spin" />
      <span className="text-sm">Criando e-mail...</span>
    </div>
  );
}
